import { Button, Box } from "@mui/material";

function IconAndTextButton({ src = "", children, onClick }) {
  return (
    <Button
      variant="text"
      onClick={onClick}
      sx={{
        textTransform: "none",
        fontSize: "14px",
        color: "#000000",
        padding: 0,
        minWidth: "auto",
        "& .MuiButton-startIcon": { marginRight: "6px" },
      }}
      startIcon={<Box component="img" src={src} sx={{ width: 16, height: 16 }} />}
    >
      {children}
    </Button>
  );
}

export default IconAndTextButton;
